import { InjectedFormProps, reduxForm } from 'redux-form';
import { ReleaseStrategy } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { dateString, presence, timeString, validation } from '@mews-commander/legacy-form';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { ReleaseDateField } from '../../../../availabilityBlockEntityForm/components/ReleaseDateField';

export interface ReleasedDateFormValues {
    blockReleaseStrategy: ReleaseStrategy;
    date: string;
    time: string;
    offsetDays: number;
    offsetTime: string;
}

type ReleasedDateContentProps = WithAvailabilityBlockId &
    InjectedFormProps<ReleasedDateFormValues, WithAvailabilityBlockId>;

const ReleasedDateContentComponent: React.FC<ReleasedDateContentProps> = ({ form }) => (
    <Stack vertical spacing="200">
        <ReleaseDateField form={form} />
    </Stack>
);

export const getConstraints = (_: unknown, { blockReleaseStrategy }: { blockReleaseStrategy: ReleaseStrategy }) => ({
    ...(blockReleaseStrategy === ReleaseStrategy.FixedReleaseUtc
        ? { date: { dateString, presence }, time: { presence, timeString } }
        : {}),
    ...(blockReleaseStrategy === ReleaseStrategy.RollingReleaseOffset
        ? { offsetDays: { presence }, offsetTime: { presence, timeString } }
        : {}),
});

export const ReleasedDateContent = reduxForm<ReleasedDateFormValues, WithAvailabilityBlockId>({
    enableReinitialize: true,
    validate: validation(getConstraints),
})(ReleasedDateContentComponent);
